import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import { withIntl, IntlProps } from 'ha/i18n';
import * as SearchFilters from 'ha/types/SearchFilters';

import FilterSwitchGroup from './FilterSwitchGroup';

interface Props {
  value: SearchFilters.RecentlyAddedFilterValue;
  className?: string;
  onChange: (value: SearchFilters.RecentlyAddedFilterValue) => void;
}

interface RecentlyAddedOption {
  value: SearchFilters.RecentlyAddedValue;
  label: string;
  'data-test-locator'?: string;
}

export const RecentlyAddedFilter: React.SFC<Props & IntlProps> = ({
  value,
  onChange,
  intl: { T },
}) => (
  <React.Fragment>
    <Typography variant="subheading">{T('Recently added listings')}</Typography>

    <FilterSwitchGroup
      value={value as string}
      onChange={(val: SearchFilters.RecentlyAddedFilterValue) => onChange(val)}
      options={
        [
          {
            value: '1-day',
            label: T('Last 24 hours'),
            'data-test-locator': 'Filter Last 24',
          },
          {
            value: '3-days',
            label: T('Last 3 days'),
            'data-test-locator': 'Filter Last 3',
          },
          {
            value: '7-days',
            label: T('Last 7 days'),
            'data-test-locator': 'Filter Last 7',
          },
          {
            value: '14-days',
            label: T('Last 14 days'),
            'data-test-locator': 'Filter Last 14',
          },
        ] as RecentlyAddedOption[]
      }
    />
  </React.Fragment>
);

export default withIntl(RecentlyAddedFilter);
